module.exports = __webpack_public_path__ + "static/media/dwu_logo.3a7ef87b.svg";